import { render } from "./SkillComponent.vue?vue&type=template&id=28677a35&scoped=true"
import script from "./SkillComponent.vue?vue&type=script&lang=js"
export * from "./SkillComponent.vue?vue&type=script&lang=js"

import "./SkillComponent.vue?vue&type=style&index=0&id=28677a35&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28677a35"]])

export default __exports__